if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('.product-form__submit-text');

        if (!this.form || !this.submitButton || !this.submitButtonText) return;

        this.variantIdInput && (this.variantIdInput.disabled = false);
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.form.addEventListener('keydown', this.onFormKeydown.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      updateHeaderCartCount(itemCount) {
        if (typeof itemCount !== 'number') return;

        document
          .querySelectorAll('.cart-count-bubble span[aria-hidden="true"], #cart-icon-bubble-footer')
          .forEach((el) => {
            el.textContent = itemCount;
          });
      }

      dispatchCartUpdatedEvent(cartData) {
        const event = new CustomEvent('cart:updated', {
          detail: {
            cart: cartData,
            totalPrice: cartData.total_price,
            items: cartData.items,
            timestamp: Date.now()
          },
          bubbles: true
        });
        document.dispatchEvent(event);
      }

      fetchAndUpdateCart() {
        if (!this.cart) return Promise.resolve();

        const sections = this.cart.getSectionsToRender();
        const sectionFetches = sections.map(section =>
          fetch(`/?section_id=${section.id}`).then(r => r.text())
        );

        return Promise.all([...sectionFetches, fetch('/cart.js').then(r => r.json())])
          .then((results) => {
            const cartData = results.pop();
            const sectionsHtml = {};
            sections.forEach((section, index) => {
              sectionsHtml[section.id] = results[index];
            });

            this.dispatchCartUpdatedEvent(cartData);
            this.cart.renderContentsFromHTML(sectionsHtml);
          });
      }

      handleBundleProductSubmit(bundleProducts) {
        const sectionId = bundleProducts.dataset.section;
        if (!sectionId) return;

        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity') || '1', 10);

        const productId = this.form.querySelector('[name="product-id"]')?.value ||
          this.closest('product-card')?.dataset.productId ||
          this.dataset.productId;

        const productHandle = this.form.querySelector('[name="product-handle"]')?.value ||
          this.closest('product-card')?.dataset.handle ||
          this.dataset.handle;

        if (!variantId || !productId || !productHandle) return;

        let bundleData = bundleProducts.storage || {};

        const limit = parseInt(bundleProducts.dataset.limit);
        const productCount = Object.keys(bundleData).length;

        if (limit > 0 && productCount >= limit && !bundleData[productId]) {
          return;
        }

        if (!bundleData[productId]) {
          bundleData[productId] = {};
        }

        bundleData[productId][variantId] = quantity;

        bundleProducts.storage = bundleData;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.submitButton.querySelector('.loading-spinner');
        if (spinner) spinner.classList.remove('hidden');

        const sectionUrl = `${window.shopUrl}/products/${productHandle}?section_id=async-bundle-product-item&variant=${variantId}`;

        fetch(sectionUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.bundle-cart__product-wrapper');

            this.submitButton.setAttribute('aria-disabled', false);
            this.submitButton.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');

            if (typeof publish !== 'undefined') {
              publish(PUB_SUB_EVENTS.bundleProductAdded, {
                sectionId,
                productId,
                variantId,
                quantity,
                bundleData,
                html: html ? html.innerHTML : null
              });
            }
          })
      }

      onFormKeydown(evt) {
        if (evt.key !== 'Enter') return;
        if (!(evt.target instanceof HTMLSelectElement)) return;

        evt.preventDefault();
        evt.stopPropagation();
      }


      onSubmitHandler(evt) {
        const recentSelectEnter = window.__triumphLastSelectEnter;
        const isRecentSelectEnterSubmit = Boolean(
          recentSelectEnter &&
          recentSelectEnter.formId === this.form?.id &&
          Date.now() - recentSelectEnter.timestamp < 1000
        );

        evt.preventDefault();

        if (isRecentSelectEnterSubmit && !evt.submitter) {
          return;
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.submittedFromSticky = this.submitButton.dataset.stickySubmit === 'true';
        const submittedFromCartChildPanel = Boolean(
          this.closest('#CartChildPanel') || this.closest('drawer-compared')
        );

        const bundleProducts = this.form.closest('bundle-products');
        if (bundleProducts) {
          this.handleBundleProductSubmit(bundleProducts);
          return;
        }

        const qtyInput = this.form.querySelector('input[name="quantity"]');
        if (qtyInput) {
          const value = parseInt(qtyInput.value, 10);
          const min = parseInt(qtyInput.min, 10) || 1;
          const max = parseInt(qtyInput.max, 10);
          const step = parseInt(qtyInput.step, 10) || 1;

          let message = '';
          if (isNaN(value) || value < min) {
            message = window.quickOrderListStrings.min_error.replace('[min]', min);
          } else if (max && value > max) {
            message = window.quickOrderListStrings.max_error.replace('[max]', max);
          } else if (value % step !== 0) {
            message = window.quickOrderListStrings.step_error.replace('[step]', step);
          }

          if (message) {
            const qtyComponent = qtyInput.closest('quantity-input');
            if (isNaN(value) || value < min) {
              qtyInput.value = min;
              qtyComponent?.onInputChange();
            } else if (max && value > max) {
              qtyInput.value = max;
              qtyComponent?.onInputChange();
            }
            qtyInput.setCustomValidity(message);
            qtyInput.reportValidity();
            return;
          } else {
            qtyInput.setCustomValidity('');
          }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.submitButton.querySelector('.loading-spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
          const inventoryData = this.form.querySelector(
            '[data-order-in-variants]'
          );

          if (inventoryData) {
            try {
              const variants = JSON.parse(inventoryData.textContent);
              const selectedId = String(formData.get('id'));
              const selectedVariant = variants.find(
                (variant) => String(variant.id) === selectedId
              );

              if (selectedVariant) {
                const propertyName = 'properties[Special order]';
                const isOrderIn =
                  !selectedVariant.preorder &&
                  selectedVariant.tracked &&
                  selectedVariant.policy === 'continue' &&
                  selectedVariant.quantity <= 0;

                if (isOrderIn) {
                  formData.set(
                    propertyName,
                    'additional processing time required'
                  );
                } else {
                  formData.delete(propertyName);
                }
              }
            } catch (error) {
              console.error('Could not read order-in inventory data.', error);
            }
          }
        if (this.cart) {
          if (submittedFromCartChildPanel && typeof this.cart.setPendingFocusRestoreElement === 'function') {
            this.cart.setPendingFocusRestoreElement(document.activeElement);
          }
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (!submittedFromCartChildPanel) {
            this.cart.setActiveElement(document.activeElement);
          }
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then(async (response) => {
            let responseData = {};

            try {
              responseData = await response.json();
            } catch (_error) {
              responseData = {};
            }

            if (!response.ok) {
              responseData.status = responseData.status || response.status;
              if (response.status === 429 && !responseData.description) {
                responseData.description = 'Too many requests. Please wait a few seconds and try again.';
              }
            }

            return responseData;
          })
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description || response.message);
              if (this.submittedFromSticky) this.scrollToErrorTop();

              this.fetchAndUpdateCart();

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              const isSoldOut = Number(response.status) === 422;
              if (!soldOutMessage || !isSoldOut) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // Silent mode: no built-in cart UI. Keep the AJAX add, skip the
              // redirect, and just fire cart update events so a third-party
              // cart drawer app can catch them and render itself.
              if (window.cartType === 'silent') {
                if (!this.error) {
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    cartData: response,
                  });
                  fetch('/cart.js')
                    .then((r) => r.json())
                    .then((cart) => {
                      this.updateHeaderCartCount(cart.item_count);
                      this.dispatchCartUpdatedEvent(cart);
                    });
                }
                this.error = false;
                return;
              }

              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
              fetch('/cart.js')
                .then(r => r.json())
                .then(cart => {
                  this.dispatchCartUpdatedEvent(cart);
                });
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                if (submittedFromCartChildPanel && this.cart?.tagName === 'CART-DRAWER') {
                  this.cart.skipNextComplementaryRerender = true;
                }
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            this.handleErrorMessage(window.variantStrings?.unavailable || 'Something went wrong. Please try again.');
            console.error('[ProductForm] onSubmitHandler fetch error:', e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.querySelector('.loading-spinner').classList.add('hidden');
            delete this.submitButton.dataset.stickySubmit;
            this.submittedFromSticky = false;

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      scrollToErrorTop() {
        const sectionHeader = document.querySelector('.section-header');
        const headerOffset = (sectionHeader?.offsetHeight || 0) + 16;
        const targetTop = Math.max(window.scrollY + this.getBoundingClientRect().top - headerOffset, 0);

        window.scrollTo({
          top: targetTop,
          behavior: 'smooth',
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper') || this.closest('product-card')?.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        const productCard = this.form.closest('product-card');
        const isBundleProduct = productCard?.hasAttribute('data-bundle-product');

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && !isBundleProduct) {
            const firstTextNode = Array.from(this.submitButtonText.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
            if (firstTextNode) {
              firstTextNode.textContent = text;
            } else {
              this.submitButtonText.prepend(text);
            }
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          if (!isBundleProduct) {
            const firstTextNode = Array.from(this.submitButtonText.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
            if (firstTextNode) {
              firstTextNode.textContent = window.variantStrings.addToCart;
            } else {
              this.submitButtonText.prepend(window.variantStrings.addToCart);
            }
          }
        }
      }

      updateButtonPrice(variant) {
        const priceElement = this.submitButton.querySelector('.product-form__button-price');
        if (!priceElement || !variant) return;

        priceElement.dataset.itemPrice = variant.price;

        const moneyFormat = priceElement.dataset.moneyFormat;
        const currency = priceElement.dataset.currency;
        const formattedPrice = formatMoneyShopify(variant.price, moneyFormat, currency);

        priceElement.innerHTML = formattedPrice;
      }

      get variantIdInput() {
        return this.form?.querySelector('[name=id]');
      }
    }
  );
}
